
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M18 36v-4.091M27 10.636c0 7.364-4.91 11.455-9 11.455S9 18 9 10.636M6.545 10.636h22.91M8.182 10.636v-.818C8.182 4.396 12.578 0 18 0s9.818 4.396 9.818 9.818v.818M18 2.455V0v.818"}}),_c('circle',{attrs:{"cx":"18","cy":"9","r":"1.636"}}),_c('path',{attrs:{"d":"M33.059 28.986l-10.15-4.44a8.182 8.182 0 01-9.818 0l-10.146 4.44A4.91 4.91 0 000 33.483V36h36v-2.517a4.91 4.91 0 00-2.941-4.497h0zM13.091 24.545V20.2M22.909 24.545V20.2"}})])])
          )
        }
      }
    